import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import {
  changeProjetoValue,
  loadHistoricoAvaliacoes,
  saveProjeto,
} from '../../../../../store/modules/ProjetoActions';

import { Col } from '../../../../../components/Col';
import { CustomCard } from '../../../../../components/CustomCard';
import { CustomTextArea } from '../../../../../components/CustomTextArea';
import { GenericProjectCard } from '../../../../../components/GenericProjectCard';
import { Row } from '../../../../../components/Row';
import { openModal } from '../../../../../store/modules/ModalActions';
import { etapaIsUnlocked } from '../../../../../utils/ProjetoUtils';

class Etapa7Card1 extends GenericProjectCard {
  stepIndex = 8;

  validationResults = [false];

  constructor(props) {
    super(props);

    this.state = {
      ...(this.state || {}),
      descricaoAtividadeIntegradoraChanged: false,
    };

    this.setValue = this.setValue.bind(this);
  }

  UNSAFE_componentWillMount() {
    this.props.loadHistoricoAvaliacoes(this.props.projeto.id, this.stepIndex);
  }

  descricaoAtividadeIntegradoraIsValid() {
    return this.props.projeto.descricaoAtividadeIntegradora
      ? this.props.projeto.descricaoAtividadeIntegradora.length > 0
      : false;
  }

  render() {
    this.validationResults = !etapaIsUnlocked(
      this.stepIndex,
      this.props.projeto.avaliacoes
    )
      ? [true]
      : [this.descricaoAtividadeIntegradoraIsValid()];
    return (
      <CustomCard
        stepIndex={this.stepIndex}
        titleHint={this.props.languageValues.hintEtapa7}
        CardHeaderPropTypes={{
          title: this.props.languageValues.etapa7,
        }}
      >
        <form
          className={this.getFormClasses(this.state.sending)}
          onSubmit={(event) => {
            event.preventDefault();
            if (this.itemsAreValid(this.validationResults)) {
              this.toNext();
            }
          }}
        >
          <Row className='form-row'>
            <Col cols={[12, 12, 12, 12, 12]}>
              <CustomTextArea
                label={this.props.languageValues.descricaoAtividadeIntegradora}
                name='descricaoAtividadeIntegradora'
                value={this.props.projeto.descricaoAtividadeIntegradora || ''}
                onChange={(event) => {
                  this.setValue(event);
                }}
                error={!this.descricaoAtividadeIntegradoraIsValid()}
                counter={true}
                maxSize={2000}
                disabled={
                  this.props.lockedAllFields ||
                  !etapaIsUnlocked(
                    this.stepIndex,
                    this.props.projeto.avaliacoes
                  )
                }
              />
            </Col>
          </Row>
          {this.getActionsRow([
            [
              null,
              this.getHistoryButton(
                this.props.languageValues.reviewButton,
                this.props.languageValues.etapa7,
                this.props.projeto.historico &&
                  this.props.projeto.historico[this.stepIndex]
                  ? this.props.projeto.historico[this.stepIndex]
                  : [],
                this.stepIndex,
                this.props.openModal
              ),
            ],
            [
              null,
              this.getNextButton(
                !etapaIsUnlocked(
                  this.stepIndex,
                  this.props.projeto.avaliacoes
                ) || this.itemsAreValid(this.validationResults)
              ),
            ],
          ])}
        </form>
      </CustomCard>
    );
  }
}

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  projeto: state.projeto.projetoEditing,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeProjetoValue,
      saveProjeto,
      loadHistoricoAvaliacoes,
      openModal,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Etapa7Card1));
